import React, { Fragment, useEffect, useState } from "react";
import { Row, Col } from 'reactstrap';
import  classNames from  'classnames';

import LeftHeader  from "./leftbar";
import RightHeader from "./rightbar";

import User        from "~/services/user";

import pointsIcon from "~/assets/images/star.png";

const Header = ({expanded})=> {

  const [user, setUser] = useState(null);

  useEffect(()=> {
    (async ()=> {
      setUser(await User.account());
    })();
  }, []);


  if(!user) return null;

  return (
    <Fragment>
      <div className={ classNames("page-header", { expanded }) }>

        <Row className="header-wrapper">
          <LeftHeader expanded={expanded} />
          <RightHeader user={user} />
        </Row>

        { expanded && <Row className="header-wrapper">
          <Col size={12}>
            <h4> Hello {user?.firstName} {user?.lastName} </h4>
          </Col>
        </Row> }

        { expanded && <div className="user-points">
          <p className="left"> <img src={pointsIcon} /> Points in your wallet </p>
          <p className="right"> {user?.points} </p>
        </div> }

      </div>
    </Fragment>
  );

};

export default Header;
